import { render, staticRenderFns } from "./messageTemplateLog.vue?vue&type=template&id=2850b9d5"
import script from "./messageTemplateLog.vue?vue&type=script&lang=js"
export * from "./messageTemplateLog.vue?vue&type=script&lang=js"
import style0 from "./messageTemplateLog.vue?vue&type=style&index=0&id=2850b9d5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports